import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormTrigger = () => (
  <ComponentDocs
    name="<Form.Trigger/>"
    entry="FieldTrigger"
    propsEntry="FieldTriggerProps"
  >
    <ComponentExample
      name="Clear another field"
      import={import("examples/Forms/FormTrigger/ClearAnotherFieldExample")}
      rawImport={import(
        "examples/Forms/FormTrigger/ClearAnotherFieldExample?raw"
      )}
    />
    <ComponentExample
      name="Match function"
      import={import("examples/Forms/FormTrigger/MatchFunctionExample")}
      rawImport={import("examples/Forms/FormTrigger/MatchFunctionExample?raw")}
    />
    <ComponentExample
      name="Trigger source"
      description="The trigger source prop can be used to restrict the origin of changes to the trigger field. This is particularly useful when two fields each have triggers that update the other field."
      import={import("examples/Forms/FormTrigger/TriggerSourceExample")}
      rawImport={import("examples/Forms/FormTrigger/TriggerSourceExample?raw")}
    />
    {/* <ComponentExample
      name="Multiple trigger fields"
      description="A trigger can listen for events across more than one field."
      import={import("examples/Forms/FormTrigger/MultipleTriggerFieldsExample")}
      rawImport={import(
        "examples/Forms/FormTrigger/MultipleTriggerFieldsExample?raw"
      )}
    />
    <ComponentExample
      name="Multiple target fields"
      description="A trigger can apply changes to more than one target field."
      import={import("examples/Forms/FormTrigger/MultipleTargetFieldsExample")}
      rawImport={import(
        "examples/Forms/FormTrigger/MultipleTargetFieldsExample?raw"
      )}
    /> */}
  </ComponentDocs>
);

export default FormTrigger;
